import React from 'react';
import { FaCertificate, FaUserGraduate, FaHandshake, FaTools } from 'react-icons/fa';

const TrustBadges = () => {
  const badges = [
    {
      icon: <FaCertificate />,
      title: "Government Empanelled",
      description: "SBPDCL, NBPDCL & JBVNL Approved"
    },
    {
      icon: <FaUserGraduate />,
      title: "Engineer-Led Team",
      description: "NIT Hamirpur & DTU Alumni"
    },
    {
      icon: <FaHandshake />,
      title: "DPIIT Recognized",
      description: "Green Technology Startup"
    },
    {
      icon: <FaTools />,
      title: "Complete O&M Support",
      description: "5 Years Service Guarantee"
    }
  ];

  return (
    <section className="trust-badges">
      <div className="container">
        <div className="badges-grid">
          {badges.map((badge, index) => (
            <div className="badge-item" key={index}>
              <div className="badge-icon">
                {badge.icon}
              </div>
              <div className="badge-content">
                <h4>{badge.title}</h4>
                <p>{badge.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
